import { useEffect, useCallback } from 'react';

const FileListeners = ({ eventEmitter, applyStoreAction }) => {
    const fileProcessed = useCallback(file => {
        applyStoreAction({
            type: 'FILE_ADD_SOCKET',
            payload: {
                fileId: file.id,
                file,
                withUpload: true
            }
        });
    }, [applyStoreAction]);

    const fileAdded = useCallback(file => {
        applyStoreAction({
            type: 'FILE_ADD_SOCKET',
            payload: {
                fileId: file.id,
                file
            }
        });
    }, [applyStoreAction]);

    const fileUpload = useCallback(file => {
        applyStoreAction({
            type: 'FILE_UPLOAD_PROGRESS',
            payload: {
                fileId: file.file_id,
                fileName: file.name,
                loaded: file.loaded
            }
        });
    }, [applyStoreAction]);

    const fileRemoved = useCallback(({ file_id }) => {
        applyStoreAction({
            type: 'FILE_REMOVE_SOCKET',
            payload: { fileId: file_id }
        });
    }, [applyStoreAction]);

    const listen = () => {
        eventEmitter.on('file_processed', fileProcessed);
        eventEmitter.on('file_added', fileAdded);
        eventEmitter.on('file_upload', fileUpload);
        eventEmitter.on('file_removed', fileRemoved);

        return () => {
            eventEmitter.off('file_processed', fileProcessed);
            eventEmitter.off('file_added', fileAdded);
            eventEmitter.off('file_upload', fileUpload);
            eventEmitter.off('file_removed', fileRemoved);
        };
    };

    useEffect(listen, [eventEmitter, fileProcessed, fileAdded, fileUpload, fileRemoved]);

    return null;
}

export default FileListeners;
